// Gauge meter — полукруг с указателем для composite Health Score (0..100).
// Три семантических тона вместо градиентной шкалы: промежуточные оттенки
// ничего не сообщали, а в тёмной теме читались хуже.

type Props = {
  value: number; // 0..100
  className?: string;
  label?: string;
  size?: number; // диаметр в px (default 200)
};

const STROKE = 14;

function colorForValue(v: number): string {
  if (v >= 60) return 'var(--positive)';
  if (v >= 35) return 'var(--warn)';
  return 'var(--negative)';
}

export function Gauge({ value, className, label, size = 200 }: Props): JSX.Element {
  const v = Math.max(0, Math.min(100, value));
  const radius = (size - STROKE) / 2;
  // Полукруг: длина = π × r.
  const arcLen = Math.PI * radius;
  const filled = (v / 100) * arcLen;
  const cx = size / 2;
  const cy = size / 2;
  const color = colorForValue(v);

  // SVG: рисуем полукруг через path сверху (от 180° до 0°).
  // Параметры пути для полукруглой дуги.
  const pathD = `M ${STROKE / 2} ${cy} A ${radius} ${radius} 0 0 1 ${size - STROKE / 2} ${cy}`;

  return (
    <div
      className={`gauge ${className ?? ''}`}
      style={{ width: size, height: size / 2 + 16 }}
    >
      <svg width={size} height={size / 2 + 8} viewBox={`0 0 ${size} ${size / 2 + 8}`}>
        {/* Bg-дуга */}
        <path
          d={pathD}
          fill="none"
          stroke="var(--rule)"
          strokeWidth={STROKE}
          strokeLinecap="round"
        />
        {/* Filled-дуга */}
        <path
          d={pathD}
          fill="none"
          strokeWidth={STROKE}
          strokeLinecap="round"
          strokeDasharray={`${filled} ${arcLen}`}
          style={{ stroke: color, transition: 'stroke-dasharray 0.5s ease, stroke 0.3s ease' }}
        />
      </svg>
      <div className="gauge-center">
        <div className="gauge-value">{Math.round(v)}</div>
        {label ? <div className="gauge-label">{label}</div> : null}
      </div>
    </div>
  );
}
